// Renders money as "1 234,56 €": number first, comma decimal, a space as the thousands
// separator and before the symbol. Matches the PHP formatMoney() helper so prices look
// identical on the web, in PDFs and on print.
// TODO: render a spinner for the loading (NaN) state instead of the '...' placeholder.
export const formatPrice = (value: number, currencySymbol: string): string => {
    if (isNaN(value)) {
        return `... ${currencySymbol}`;
    }

    const [integerPart, decimalPart] = value.toFixed(2).split('.');
    const groupedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    return `${groupedInteger},${decimalPart} ${currencySymbol}`;
};
